import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ordenes',
    templateUrl: './ordenes.component.html',
    styleUrls: ['./ordenes.component.scss'],
    standalone: false
})
export class OrdenesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
